import { useEffect, useState } from 'react'
import { useMainHeaderElement } from '~/context/mainHeaderElement'
import { useIntersection } from './useIntersection'

/**
 * ヘッダーがメインとサブの２つあり、それぞれ`position:sticky`であるような場合にサブヘッダーがフローティング状態かを判定する
 * @returns サブヘッダー取得用のref, フローティングしているかの結果
 */
export const useSubHeaderFloating = () => {
  const [options, setOptions] = useState<IntersectionObserverInit>({
    // 正確なoptionsがセットされるまでは常にintersectionがfalseになるようなrootMarginを設定
    rootMargin: '-9999px -9999px -9999px -9999px',
  })
  const [subHeaderRef, intersection] = useIntersection(options)
  const mainHeaderElement = useMainHeaderElement()

  useEffect(() => {
    const updateOptions = () => {
      const mainHeaderHeight = (mainHeaderElement?.clientHeight ?? 0) + 1
      setOptions({
        rootMargin: `0px 0px ${
          mainHeaderHeight - document.documentElement.clientHeight
        }px 0px`,
        threshold: 0,
      })
    }
    updateOptions()

    window.addEventListener('resize', updateOptions)
    return () => window.removeEventListener('resize', updateOptions)
  }, [mainHeaderElement])

  return {
    subHeaderRef,
    floating: intersection,
  }
}
